import { render, staticRenderFns } from "./Usersnap.vue?vue&type=template&id=a8f1d9de&scoped=true"
import script from "./Usersnap.vue?vue&type=script&lang=js"
export * from "./Usersnap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f1d9de",
  null
  
)

export default component.exports